import { AnglePoints } from "../types/Interface";
import calculateAngles from "./calculateAngles";
import generateAngle from "./generateAngle";


export function generateAngles(p: AnglePoints, clockwise: boolean,) {
  const { startRadian, endRadian } = calculateAngles(p.curr, p.prev, p.next);
  const degree = generateAngle({ startRadian, endRadian }, clockwise, false);
  return {
    startRadian,
    endRadian,
    degree
  }
}